export default __webpack_public_path__ + "static/media/logo-dark.81983787.png";